export default {
  "pl": {
    "inspiration": {
      "actions": {
        "delete": "Usuń",
        "deleteMultipleInspirations": "Usuń…",
        "delete_cancel": "Cofnij usunięcie",
        "goBackToInspirationLists": "Inspiracje",
        "new": "Dodaj zdjęcie"
      },
      "labels": {
        "noInspirations": "Nie masz jeszcze żadnej inspiracji",
        "upload_autoclose": "To okno zamknie się automatycznie po przesłaniu wszystkich obrazów."
      },
      "toasts": {
        "upload_success": "Przesłano {count} inspirację | Przesłano następującą liczbę inspiracji: {count}"
      }
    }
  }
}
